<template>
 <div class="exel">
   <div class="row">
     <div class="col-12">
       <button @click="saveAccounts" class="mr-3 mb-2 mt-2 btn btn-success btn-lg pull-right" type="button"> Save Account List</button>
       <button @click="saveAccounts" class="mr-3 mb-2 mt-2 btn btn-danger btn-lg pull-right" type="button"> Remove All</button>
     </div>
   </div>
   <hot-table :settings="settings" licenseKey="non-commercial-and-evaluation" :data.sync="data"></hot-table>
   <loading :active.sync="isLoading"></loading>
 </div>
</template>

<script>
    import { HotTable } from '@handsontable/vue';

    export default {
        name: 'paymentAccounts',
        props: ['id'],
        data: function() {
            return {
                isLoading: false,
                settings: {colWidths: 100,
                    width: '100%',
                    height: 800,
                    rowHeaders: true,
                    colHeaders: true,
                    selectionMode: 'multiple',
                    columnSorting: true,
                    search: true,
                    filters: true,
                    minRows: 200,
                    fixedRowsBottom: 1,
                    stretchH: 'all',
                    colHeaders: ['Owner','Identifier Number', 'Deposit', 'Withdraw', 'Max Limit', 'Iban', 'Swift' ,'Is Active'],
                    columns: [
                        {
                            data: 'owner_name'
                            // 1nd column is simple text, no special options here
                        },
                        {
                            data: 'identifier'
                            // 1nd column is simple text, no special options here
                        },
                        {
                            data: 'deposit',
                            type: 'numeric',
                            numericFormat: {
                                pattern: '$0,0.00',
                                culture: 'en-US' // this is the default culture, set up for USD
                            },
                            allowEmpty: false
                        },
                        {
                            data: 'withdraw',
                            type: 'numeric',
                            numericFormat: {
                                pattern: '$0,0.00',
                                culture: 'en-US' // this is the default culture, set up for USD
                            },
                            allowEmpty: false
                        },
                        {
                            data: 'limit',
                            type: 'numeric',
                            numericFormat: {
                                pattern: '$0,0.00',
                                culture: 'en-US' // this is the default culture, set up for USD
                            },
                            allowEmpty: false
                        },
                        {
                            data: 'iban'
                            // 1nd column is simple text, no special options here
                        },
                        {
                            data: 'swift_code'
                            // 1nd column is simple text, no special options here
                        },
                        {
                            data: 'is_active',
                            type: 'checkbox',
                            checkedTemplate: true,
                            uncheckedTemplate: false,
                            className: "text-center"
                        }
                    ],
                    columnSummary: [

                    ],
                },
                data: [],
            };
        },
        components: {
            HotTable
        },
        watch: {
            'id' () {
                this.fetchAccounts();
            }
        },
        mounted () {
            setTimeout(this.init(), 500);
            setTimeout(this.fetchAccounts(), 1500);
        },
        methods: {
            init () {
                this.data = [];
            },
            fetchAccounts () {
                this.isLoading = true;
                this.$http.get(api+'api/v1/payment/accounts/'+this.id).then(response => {

                    this.data = response.body;
                    this.isLoading = false;
                }, response => {
                    this.isLoading = false;
                })
            },
            saveAccounts () {
                this.isLoading = true;
                this.$http.post(api+'api/v1/payment/accounts/'+this.id,
                    { data: this.data }).then(response => {
                    this.data = response.body;
                    this.isLoading = false;
                }, response => {
                    this.isLoading = false;
                })
            }
        }
    }
</script>

<style scoped>
  .exel {
    text-align: left;
    width: 1000px;
    background: white;
    color: black
  }
</style>



// WEBPACK FOOTER //
// src/components/payment/paymentAccounts.vue